import { useTranslation } from 'react-i18next'
import SelectUnique from '@/components/_custom/Selector/selectUnique/selectUnique'
import { SelectOptionsDeprecated } from '@/types/Select'
import { OccasionalSlotsPlaces } from '@/types/Slots'
import styles from '../../occasionalSlotForm.module.scss'
import { useDialog } from '@/hooks/useDialog/useDialog'
import Places from '@/container/daycare/daycareProfile/settings/modals/places'

interface SlotPlaceFieldProps {
    places: OccasionalSlotsPlaces[]
    value: number | undefined
    onChange: (value: number | undefined) => void
}

export default function SlotPlaceField({ places, value, onChange }: SlotPlaceFieldProps) {
    const { t } = useTranslation()

    const resourceLabel: string = t('myPlaces')
    const { dialog, openDialogActionItem, reopenTrigger } = useDialog({
        dialogTitle: resourceLabel,
        Component: Places,
        resourceLabel: { type: 'manageResource', label: resourceLabel }
    })

    const options: SelectOptionsDeprecated = [
        {
            options: [
                ...places.map((place) => ({ name: place.name, value: String(place.id) })),
                { name: t('noPlaces'), value: '' }
            ]
        }
    ]

    return (
        <>
            <SelectUnique
                selectOptions={options}
                selectValue={value?.toString() ?? ''}
                setSelectValue={(value: string) => onChange(value === '' ? undefined : Number(value))}
                formClassName={styles.UserInput}
                label={t('place')}
                actionItem={openDialogActionItem}
                reopenTrigger={reopenTrigger}
            />
            {dialog}
        </>
    )
}
